module.exports = __webpack_public_path__ + "img/wifi-lost-svgrepo-com.b7f4f54a.svg";